import { Currency } from 'src/types/api'

export const CURRENCY_SYMBOLS: { [key in Currency]: string } = {
  eur: '€',
  usd: '$',
  pln: 'zł',
  gbp: '£',
  try: '₺',
  dkk: 'kr',
  aed: 'د.إ',
} as const

export const TIPS_FIXED_AMOUNT_ID = 'fixed-amount' as const

export const TRANSLATIONS_KEYS = {
  'Timeslot.Info': 'Timeslot.Info',
  'Timeslot.InfoLower': 'Timeslot.InfoLower',
} as const

export const IS_STAGING = process.env.VITE_APP_ENV === 'staging'

export const FILE_SIZE = 'fileSize' as const

export const PHONE_NUMBER = 'phoneNumber' as const

export const MAX_UPLOAD_FILE_SIZE = 10000000 as const

export const GEOLOCATION_POSITION_ERROR_CODES = {
  GENERAL: 1,
  PERMISSION_DENIED: 2,
} as const

export const countryData = {
  AT: { name: 'Austria', code: '+43' },
  BE: { name: 'Belgium', code: '+32' },
  BG: { name: 'Bulgaria', code: '+359' },
  HR: { name: 'Croatia', code: '+385' },
  CY: { name: 'Cyprus', code: '+357' },
  CZ: { name: 'Czech Republic', code: '+420' },
  DK: { name: 'Denmark', code: '+45' },
  EE: { name: 'Estonia', code: '+372' },
  FI: { name: 'Finland', code: '+358' },
  FR: { name: 'France', code: '+33' },
  DE: { name: 'Germany', code: '+49' },
  GR: { name: 'Greece', code: '+30' },
  HU: { name: 'Hungary', code: '+36' },
  IS: { name: 'Iceland', code: '+354' },
  IE: { name: 'Ireland', code: '+353' },
  IT: { name: 'Italy', code: '+39' },
  LV: { name: 'Latvia', code: '+371' },
  LI: { name: 'Liechtenstein', code: '+423' },
  LT: { name: 'Lithuania', code: '+370' },
  LU: { name: 'Luxembourg', code: '+352' },
  MT: { name: 'Malta', code: '+356' },
  NL: { name: 'Netherlands', code: '+31' },
  NO: { name: 'Norway', code: '+47' },
  PL: { name: 'Poland', code: '+48' },
  PT: { name: 'Portugal', code: '+351' },
  RO: { name: 'Romania', code: '+40' },
  SK: { name: 'Slovakia', code: '+421' },
  SI: { name: 'Slovenia', code: '+386' },
  ES: { name: 'Spain', code: '+34' },
  SE: { name: 'Sweden', code: '+46' },
}